import React from "react";
import SwitcherMapMode from "./SwitcherMapMode";
import img from '../../../../../assets/images/roadmap.svg';
import { RootState } from "@/store/redux/store";
import useMode from "../../../../Map/hooks/useMode";
import { useSelector } from "react-redux";

const SwitcherRoadMap = () => {
    const mode = useSelector((state: RootState) => state.mapScreen.mapMode);
    const { onRoadmapsMode } = useMode();

    return (
        <SwitcherMapMode
            type='roadMaps'
            img={img}
            text="Маршруты"
            isActive={mode === 'roadMaps'}
            onClick={onRoadmapsMode}
        />
    )
}

export default SwitcherRoadMap;